/**
 * Password page — auto-fill and submit storefront password from email links.
 * Supports ?access=CODE or ?password=CODE (e.g. Klaviyo campaign links).
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var params = new URLSearchParams(window.location.search);
  var code = params.get('access') || params.get('password');
  if (!code) return;

  code = code.trim();
  if (!code) return;

  var attemptKey = 'intus_password_auto_' + code;
  if (sessionStorage.getItem(attemptKey)) return;

  function findPasswordForm() {
    var inputs = document.querySelectorAll('input[name="password"][type="password"]');
    for (var i = 0; i < inputs.length; i++) {
      var form = inputs[i].form;
      if (form && (form.getAttribute('action') || '').indexOf('password') !== -1) {
        return { input: inputs[i], form: form };
      }
    }
    if (inputs.length) {
      return { input: inputs[0], form: inputs[0].form };
    }
    return null;
  }

  function submitFromLink() {
    var match = findPasswordForm();
    if (!match || !match.form) return;

    sessionStorage.setItem(attemptKey, '1');
    match.input.value = code;

    if (typeof match.form.requestSubmit === 'function') {
      match.form.requestSubmit();
    } else {
      match.form.submit();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', submitFromLink);
  } else {
    submitFromLink();
  }
})();
